// 页面导出为pdf格式 //title表示为下载的标题，html表示document.querySelector('#myPrintHtml')
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import { Loading } from "element-ui";

// type为true则不需要间隙
export default function pageToPDF(title, html, lableList, type) {
  let loadingInstance = Loading.service({
    lock: true,
    text: "正在导出中，请稍后...",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  let a4w = type ? 210 : 170;
  let a4h = type ? 297 : 277; // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
  // type传有效值pdf则为横版
  if (lableList) {
    const pageHeight = Math.floor((a4h * html.scrollWidth) / a4w); //计算pdf高度
    for (let i = 0; i < lableList.length; i++) {
      //循环获取的元素
      const multiple = Math.ceil((lableList[i].offsetTop + lableList[i].offsetHeight) / pageHeight); //元素的高度
      //计算是否超出一页
      let _H = multiple * pageHeight - (lableList[i].offsetTop + lableList[i].offsetHeight);
      let newNode = getFooterElement(_H); //向pdf插入空白块的内容
      const divParent = lableList[i].parentNode; // 获取该div的父节点
      const next = lableList[i].nextSibling; // 获取div的下一个兄弟节点
      // 判断兄弟节点是否存在
      if (next) {
        // 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
        divParent.insertBefore(newNode, next);
      }
    }
  }
  html2Canvas(html, {
    allowTaint: false,
    taintTest: false,
    logging: true,
    useCORS: true,
    dpi: window.devicePixelRatio * 1,
    scale: 1, // 按比例增加分辨率
  }).then((canvas) => {
    let pdf = new JsPDF("p", "mm", "a4"); // A4纸，纵向
    let ctx = canvas.getContext("2d");
    let imgHeight = Math.floor((a4h * canvas.width) / a4w); // 按A4显示比例换算一页图像的像素高度
    let renderedHeight = 0;
    while (renderedHeight < canvas.height) {
      let page = document.createElement("canvas");
      page.width = canvas.width;
      page.height = Math.min(imgHeight, canvas.height - renderedHeight); // 可能内容不足一页

      // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
      page
        .getContext("2d")
        .putImageData(
          ctx.getImageData(
            0,
            renderedHeight,
            canvas.width,
            Math.min(imgHeight, canvas.height - renderedHeight)
          ),
          0,
          0
        );
      pdf.addImage(
        page.toDataURL("image/jpeg", 1.0),
        "JPEG",
        type ? 0 : 20,
        type ? 0 : 20,
        a4w,
        Math.min(a4h, (a4w * page.height) / page.width)
      ); // 添加图像到页面，保留10mm边距
      renderedHeight += imgHeight;
      if (renderedHeight < canvas.height) {
        pdf.addPage(); // 如果后面还有内容，添加一个空页
      }
    }
    // 保存文件
    pdf.save(title + ".pdf");
    // 以服务的方式调用的 Loading 需要异步关闭
    loadingInstance.close();
  });
}
// pdf截断需要一个空白位置来补充
function getFooterElement(remainingHeight) {
  const newNode = document.createElement("div");
  newNode.style.background = "#ffffff";
  newNode.style.height = remainingHeight + "px";
  return newNode;
}
